import { formatCurrency } from "@/common/helpers/mask.helpers";
import { PAYMENT_STATUS } from "@/types/payment.type";
import { getStatusLabelsPayment } from "@/modules/renters/components/payments/paymentUtils";
import { PaymentsNegativation } from "../../helpers/paymentCalculations.helper";
import { TableSelector } from "@/common/components/ui/table/tableSelector";

interface PaymentSelectorProps {
  payments: PaymentsNegativation[];
  selectedPayments: PaymentsNegativation[];
  onPaymentToggle: (payment: PaymentsNegativation) => void;
}

export function PaymentSelector({
  payments,
  selectedPayments,
  onPaymentToggle
}: PaymentSelectorProps) {

  const getStatusColor = (status: string) => {
    const statusColors = {
      [PAYMENT_STATUS.PENDING]: "bg-blue-100 text-blue-800",
      [PAYMENT_STATUS.OVERDUE]: "bg-red-100 text-red-800",
    };
    return statusColors[status];
  };

  const renderPaymentContent = (payment: PaymentsNegativation, isSelected: boolean) => (
    <div className="flex items-center gap-3 flex-1">
      {/* Informações do pagamento */}
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-3 mb-1">
          <span className={`px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(payment.status!)}`}>
            {getStatusLabelsPayment(payment.status!)}
          </span>
        </div>
        <h3 className={`font-semibold text-sm truncate transition-colors duration-200
          ${isSelected ? "text-gray-900" : "text-gray-800"}
        `}>
          {payment.description}
        </h3>
      </div>

      {/* Valor */}
      <div className="flex-shrink-0 text-right">
        <div className={`font-bold text-lg transition-colors duration-200
          ${payment.status === PAYMENT_STATUS.OVERDUE
            ? "text-red-600"
            : payment.status === PAYMENT_STATUS.PENDING
              ? "text-blue-500"
              : "text-gray-900"
          }
        `}>
          {formatCurrency(payment.value)}
        </div>
      </div>
    </div>
  );

  return (
    <TableSelector
      items={payments}
      selectedItems={selectedPayments}
      onItemToggle={onPaymentToggle}
      renderContent={renderPaymentContent}
    />
  );
}